<p>Sensor list</p>


<ul>
    <li *ngFor="let item of sensors">
        {{item.name}}
    </li>
</ul>